import { callAxios, dev_console, isSuccess, whoAmI } from "../../../Common/ts/commonTools";
import { defaultApiReaponseInterface } from "../../../Common/interface/Common.interface";
import { contractListREST_Interface } from "../static/interface/contractListREST.interface";
import useCustomQuery from "../../../Common/hooks/useCustomQuery";

const EMPTY_LIST: contractListREST_Interface[] = [];

const useContractListREST = () => {

    const isAbleToRequest = () => {
        let result: boolean = false;

        if(whoAmI.isCustomer()){
            result = true;
        }

        return result;
    }

    const {
        data: contractListData = EMPTY_LIST,
        error: contractListDataError,
        isLoading: contractListDataLoading,
        refetch: contractListDataRefetch,
    } = useCustomQuery({
        queryKey: ["useContractListREST"],
        queryFn: getContractListData,
        enabled: isAbleToRequest,
        select: (response) => {
            let RTN: contractListREST_Interface[] = EMPTY_LIST;

            if (isSuccess(response)) {
                const data: defaultApiReaponseInterface<contractListREST_Interface[]> = response.data;
                RTN = data.result;
            }

            return RTN;
        },
    })

    // 유저 개인 정보를 호출하는 함수
    async function getContractListData(){
        const m_contract_list_url = "api/v3/customers/contract/list";

        const response = await callAxios.api({
            url: m_contract_list_url,
            method: "get",
        })

        dev_console.log(m_contract_list_url);
        dev_console.log(response);

        return response;
    }
    
    return({
        contractListData,
        contractListDataError,
        contractListDataLoading,
        contractListDataRefetch,
    })
}

export default useContractListREST;